import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authRoutes/_appWrapper/lesson/$')({
  beforeLoad: () => {
    throw redirect({
      to: '/lesson-planning',
      search: { grade: '', subject: '' },
    })
  },
  component: App,
})

function App() {
  return (
    <div className="text-center">
      <p>Redirecting to lesson planning...</p>
    </div>
  )
}
